export const STATUSES = [
  { text: 'Updating', value: 'in_progress' },
  { text: 'Completed', value: 'completed' },
  { text: 'Failed', value: 'failed' },
];

export const progressToPercent = (balanceCount, totalCount) => {
  let percent = totalCount === 0 ? 100 : 0;
  if (balanceCount > 0 && totalCount > 0) {
    percent = Math.trunc((balanceCount / totalCount) * 100);
  }
  return percent;
};



// WEBPACK FOOTER //
// ./src/utils/dataImport.js